export const recordListPageSizes = [10, 25, 50, 100] as const

export type RecordListPageSize = (typeof recordListPageSizes)[number]

const storageKey = 'apl-enterprise.record-list-page-size'

function isPageSize(value: number): value is RecordListPageSize {
  return recordListPageSizes.includes(value as RecordListPageSize)
}

export function getPreferredPageSize(
  searchParams?: URLSearchParams,
  fallback: RecordListPageSize = 25,
): RecordListPageSize {
  const requested = Number(searchParams?.get('pageSize'))
  if (isPageSize(requested)) return requested

  try {
    const stored = Number(window.localStorage.getItem(storageKey))
    return isPageSize(stored) ? stored : fallback
  } catch {
    return fallback
  }
}

export function rememberPageSize(pageSize: RecordListPageSize) {
  try {
    window.localStorage.setItem(storageKey, String(pageSize))
  } catch {
    // La URL conserva el valor aunque el navegador bloquee el almacenamiento local.
  }
}
